import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import config from "../../config";
import Cookies from "js-cookie";
import { withRouter } from "react-router";
import Loader from "../../components/loader";
import { LayoutForNoting } from "../../components/layout";
import * as tokenActions from "../../modules/token";

import { axiosWithoutHeaders } from "../../cores/axiosWrapper";

import { sessionKeeper } from "@cores/sessionKeeper";
import menuService from "@services/menuService";

// OAuth 2.0 Code 플로우 방식으로 코드 요청했을 때 redirect 되어서 들어오게 되는 페이지

class Login extends React.Component {
    componentDidMount() {
        const { history, location, TokenActions, token } = this.props;
        const { search } = location;
        const queryParams = search.replace("?", "").split("&");
        const codeParam = queryParams.find((param) => param.startsWith("code="));
        const codeValue = codeParam?.split("=")?.[1];
        if (!codeValue) {
            const welcomePath = window.location.pathname.indexOf("/library") > -1 ? "/library/welcome" : "/welcome";
            history.replace(welcomePath);
            return;
        }
        const cookieDomain = sessionKeeper.getDomain();
        const clientId = config.mz_pops.clientId;
        sessionKeeper.set({ clientId });

        const redirectUrl = `&redirectUrl=${window.location.origin}/megazone/login`;
        const apiEndpoint = `${config.host.api}/v3/oauth_token?code=${codeValue}&clientId=${clientId}${redirectUrl}`;

        axiosWithoutHeaders
            .get(apiEndpoint, {
                headers: {},
            })
            .then((response) => {
                const accessToken = response.headers["access-token"];
                if (accessToken) {
                    TokenActions.setToken(cookieDomain, response.data);
                }

                const beforeLoginUrl = Cookies.get("beforeLogin", {
                    cookieDomain,
                });

                if (beforeLoginUrl) {
                    window.location.href = beforeLoginUrl;
                } else window.location.href = `${menuService.paths.spaces()}`;
            })
            .catch((e) => {
                console.log(`failed to get access token`, e.message);
                TokenActions.deleteToken();
                window.location.href = "/welcome";
            })
            .finally(() => {
                Cookies.remove("beforeLogin", {
                    domain: cookieDomain,
                });
            });
    }

    render() {
        return (
            <LayoutForNoting>
                <Loader />
            </LayoutForNoting>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        token: state.token,
    };
};
let mapDispatchToProps = (dispatch) => {
    return {
        TokenActions: bindActionCreators(tokenActions, dispatch),
    };
};

const ConnectedLogin = connect(mapStateToProps, mapDispatchToProps)(Login);
export default withRouter(ConnectedLogin);
